import { SellerListing } from './sellerListingsCollectionReducer';
import { DRAFT } from './toolbarHelpers';
import { Insight, NEXT_BEST_ACTION_INSIGHT_TYPE } from './sellerRecommendationTracking';

export function nextBestActionInsight(listing: SellerListing): Insight | undefined {
  const insightType = listing.insights?.nextBestAction?.insightType;
  return insightType ? NEXT_BEST_ACTION_INSIGHT_TYPE[insightType] : undefined;
}

export function hasInsightRecommendation(listing: SellerListing): boolean {
  if (listing.state === DRAFT) {
    return true;
  }
  return Boolean(nextBestActionInsight(listing));
}
